export const TEMPLATE_DIFF_PREVIEW_KEY = 'template-diff-preview';
